// Skip-to-content link — hidden until keyboard-focused. WCAG 2.4.1.
export default function SkipLink() {
    return (
        <a href="#main-content" className="skip-link" data-testid="skip-link">
            Skip to main content
        </a>
    );
}
